import React from 'react';
import moment from 'moment';

import { Group } from '../../atoms/graphs';
import { DateFrequency } from '../../types/graphs';

export interface Props {
  frequency?: DateFrequency;
  intervals: Array<[number | Date, number | Date]>;
  scale: any;
}

const timeFormat = (frequency: DateFrequency): string => {
  return {
    d: 'ddd D',
    w: 'MMM D',
    M: 'MMM D',
  }[frequency];
};

class DateIntervalAxis extends React.Component<Props, any> {
  static defaultProps: Partial<Props> = {
    frequency: 'w',
  };
  private textWidth = 120;

  public render() {
    const { frequency, intervals, scale } = this.props;
    const format = timeFormat(frequency);

    return (
      <Group className="axis">
        {intervals.map(([start, end], i) => {
          const width = Math.abs(scale(start) - scale(end));
          const exclusiveStart = +moment(start).add(1, 'day');

          const label = [exclusiveStart, end]
            .map(d => moment(d).utc())
            .map(m => m.format(format))
            .join(' - ');

          return (
            <svg
              width={width}
              height="2em"
              x={scale(start)}
              key={`tick-${i}`}
              viewBox={`0 0 ${this.textWidth} 1`}
            >
              <text className="tick" x={this.textWidth / 2} textAnchor="middle">
                {label}
              </text>
            </svg>
          );
        })}
      </Group>
    );
  }
}

export default DateIntervalAxis;
